"use client"

import { Button } from "@/components/ui/button";
import { useState, useEffect } from 'react';

export function SpeelMee() {
  const [userId, setUserId] = useState<string | null>(null);
  const [teamId, setTeamId] = useState<string | null>(null);

  function extractDomain(hostname: string): string {
    const parts = hostname.split('.');
    
    if (parts.length < 2) {
      return hostname; // Return the original if it doesn't have at least one dot
    }
    
    // Get the last two parts (domain name and TLD)
    return parts.slice(-2).join('.');
  }

  const handleLogin = () => {
    // Get the current hostname to determine the root domain
    const hostname = typeof window !== 'undefined' ? window.location.hostname : '';
    
    const rootDomain = extractDomain(hostname);
    
    // Construct the login URL with the appropriate parameters
    const loginUrl = hostname === 'nu.nl' ? `https://nu.nl/login?callback_url=${window.location.origin}/login?&dpg_medium=fun&dpg_campaign=klassiekerspel` : 
      `https://account.${rootDomain}/login?callback_url=${window.location.origin}/login?&dpg_medium=fun&dpg_campaign=klassiekerspel`;
    
    // Navigate to the login URL
    window.location.href = loginUrl;
  };

  useEffect(() => {
    const getCookieValue = (name: string): string | null => {
      const value = `; ${document.cookie}`;
      const parts = value.split(`; ${name}=`);
      if (parts.length === 2) {
        const popped = parts.pop();
        return popped ? popped.split(';').shift() || null : null;
      }
      return null;
    };

    // Check for authentication
    const userId = getCookieValue('userInfo');
    if (userId) {
      setUserId(userId);
    }

    const teamId = getCookieValue('teamId');
    if (teamId) {
      setTeamId(teamId);
    }

  }, []);

  if (teamId) {
    return (
      <Button 
        variant="green" 
        onClick={() => window.location.href = '/fantasy'}
      >
        Naar jouw ploeg
      </Button>
    );
  }

  if (userId) {
    return (
      <Button 
        variant="green" 
        onClick={() => window.location.href = '/fantasy/new'}
      >
        Maak jouw ploeg
      </Button>
    );
  }

  // Return the login button for unauthenticated users
  return <Button variant="green" onClick={handleLogin}>Speel mee</Button>;
}